import { Swiper, Pagination } from 'swiper'

Swiper.use([Pagination])

const fn = {
  init: () => {
    const keyContacts = document.querySelector('.key-contacts')

    if (keyContacts) {
      fn.setupKeyContactsSlider(keyContacts)
    }
  },

  setupKeyContactsSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 1,
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
    }

    if (numSlides > 1) {
      new Swiper(container, opts)
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-housingpage'),
  run: fn.init,
}
